

























































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { ColloquiInfo } from "../../_models/colloquiInfo";
import * as user from "../../_store/user.module";
import { bus } from "../../main";

@Component
export default class EditQuestionarioColloquio extends Vue {
  @Prop() info!: ColloquiInfo;

  private idColloquio: number;
  private denominazione: string;
  private sede: string;
  private telefono: string;
  private emailAzienda: string;
  private nomeSelezionatore: string;
  private cognomeSelezionatore: string;
  private posizioneRichiesta: string;
  private valutazione: string;
  private note: string;

  private nomeAllievo: string;
  private cognomeAllievo: string;
  private classeAllievo: string;
  private luogoNascita: string;
  private dataNascita: string;
  private comuneAllievo: string;
  private indirizzoAllievo: string;
  private capAllievo: string;
  private provinciaAllievo: string;

  private posizioneRules: [boolean | string];
  private valutazioneRules: [boolean | string];
  private noteRules: [boolean | string];

  private authorized: boolean;

  constructor() {
    super();
    this.idColloquio = this.info.idColloquio;
    this.denominazione = this.info.denominazione;
    this.sede = this.info.sede;
    this.telefono = this.info.telefono;
    this.emailAzienda = this.info.emailAzienda;
    this.nomeSelezionatore = this.info.nomeSelezionatore;
    this.cognomeSelezionatore = this.info.cognomeSelezionatore;
    this.posizioneRichiesta = "";
    this.valutazione = "";
    this.note = "";

    this.nomeAllievo = this.info.nomeUtente;
    this.cognomeAllievo = this.info.cognomeUtente;
    this.classeAllievo = this.info.classe;
    this.luogoNascita = this.info.luogoNascita;
    this.dataNascita = this.info.dataNascita;
    this.comuneAllievo = this.info.comuneUtente;
    this.indirizzoAllievo = this.info.indirizzoUtente;
    this.capAllievo = this.info.cap;
    this.provinciaAllievo = this.info.provinciaUtente;

    this.posizioneRules = [true];
    this.valutazioneRules = [true];
    this.noteRules = [true];

    this.authorized = false;
  }

  close() {
    var userInfo = user.readUserInfo(this["$store"]);
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    if (userInfo.ruoloUtente.includes(3)) {
      this.cognomeSelezionatore = enterpriseInfo.cognomeRappresentanteAzienda;
      this.nomeSelezionatore = enterpriseInfo.nomeRappresentanteAzienda;
    } else if(userInfo.ruoloUtente.includes(9)){
      this.cognomeSelezionatore = userInfo.cognomeUtente;
      this.nomeSelezionatore = userInfo.nomeUtente;
    }

    this.idColloquio = this.info.idColloquio;
    this.denominazione = this.info.denominazione;
    this.sede = this.info.sede;
    this.telefono = this.info.telefono;
    this.emailAzienda = this.info.emailAzienda;
    // this.nomeSelezionatore = enterpriseInfo.nomeRappresentanteAzienda;
    // this.cognomeSelezionatore = enterpriseInfo.cognomeRappresentanteAzienda;
    this.posizioneRichiesta = "";
    this.valutazione = "";
    this.note = "";

    this.nomeAllievo = this.info.nomeUtente;
    this.cognomeAllievo = this.info.cognomeUtente;
    this.classeAllievo = this.info.classe;
    this.luogoNascita = this.info.luogoNascita;
    this.dataNascita = this.info.dataNascita;
    this.comuneAllievo = this.info.comuneUtente;
    this.indirizzoAllievo = this.info.indirizzoUtente;
    this.capAllievo = this.info.cap;
    this.provinciaAllievo = this.info.provinciaUtente;

    this.posizioneRules = [true];
    this.valutazioneRules = [true];
    this.noteRules = [true];
    bus.$emit("closeEditDialog");
  }

  validazionePosizioneRichiesta() {
    var valid: boolean = false;
    if (this.posizioneRichiesta !== "" || this.posizioneRichiesta !== null) {
      valid = /^[a-zA-Z0-9ìèéùòà'.,\x20]{2,50}$/.test(this.posizioneRichiesta);
    }
    if (valid) {
      this.posizioneRules = [true];
    } else {
      this.posizioneRules = [
        "Posizione richiesta necessaria e non deve avere più di 50 caratteri"
      ];
    }
  }
  validazioneNote() {
    var valid: boolean = false;
    if (this.valutazione === "4" || this.valutazione === "1") {
      if (this.note !== "" || this.note !== null) {
        valid = /^[a-zA-Z0-9ìèéùòà'.,\x20]{2,250}$/.test(this.note);
      }
    } else {
      valid = true;
    }

    if (valid) {
      this.noteRules = [true];
    } else {
      this.noteRules = [
        "Note necessarie e non devono avere più di 250 caratteri"
      ];
    }
  }
  validazioneValutazione() {
    if (this.valutazione !== "") {
      this.valutazioneRules = [true];
    } else {
      this.valutazioneRules = ["Necessario selezionare una valutazione"];
    }
  }
  async executeTest() {
    this.validazionePosizioneRichiesta();
    this.validazioneNote();
    this.validazioneValutazione();
  }
  save() {
    var payload = {
      idSchedulazione: 0,
      nomeSelezionatore: "",
      cognomeSelezionatore: "",
      esito: 0,
      note: "",
      posizioneRichiesta: ""
    };
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        payload = {
          idSchedulazione: this.idColloquio,
          nomeSelezionatore: this.nomeSelezionatore,
          cognomeSelezionatore: this.cognomeSelezionatore,
          esito: +this.valutazione,
          note: this.note,
          posizioneRichiesta: this.posizioneRichiesta
        };
        user
          .dispatchSendQuestionarioCV(this["$store"], payload)
          .then(() => {
            bus.$emit(
              "successfullOperation",
              "Questionario compilato correttamente"
            );
            this.close();
            bus.$emit("loadColloqui")
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      }
    });
  }

  created() {
    var userInfo = user.readUserInfo(this["$store"]);
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    if (userInfo.ruoloUtente.includes(3)) {
      this.cognomeSelezionatore = enterpriseInfo.cognomeRappresentanteAzienda;
      this.nomeSelezionatore = enterpriseInfo.nomeRappresentanteAzienda;
    } else if(userInfo.ruoloUtente.includes(9)){
      this.cognomeSelezionatore = userInfo.cognomeUtente;
      this.nomeSelezionatore = userInfo.nomeUtente;
    }
    if (userInfo.ruoloUtente.includes(3) || userInfo.ruoloUtente.includes(9)) {
      this.authorized = true;
    }
  }
}
